// /utils/auth.js
import { signIn, signOut, getSession } from 'next-auth/react'
import { toast } from 'react-toastify'

export async function loginWithCredentials({
  account,
  password,
  rememberMe = false,
  onSuccess,
  onError,
  setCartProducts,
}) {
  const res = await signIn('credentials', {
    redirect: false,
    account,
    password,
    rememberMe,
    deviceInfo: typeof navigator !== 'undefined' ? navigator.userAgent : 'web',
  })

  if (res?.ok) {
    toast.success('驗證成功')

    // 如果你需要 MemberID 做後續事（例如合併購物車）
    // const session = await getSession()
    // const MemberID = session?.MemberID || session?.user?.MemberID
    // ... 你的購物車合併流程（如需要）

    onSuccess?.()
  } else {
    toast.error('驗證失敗')
    onError?.(res)
  }
}

export async function logout({ setCartProducts, onSuccess } = {}) {
  await signOut({ redirect: false })
  toast.success('您已登出')
  if (typeof window !== 'undefined') localStorage.removeItem('cartList')
  setCartProducts?.([])
  onSuccess?.()
}
